@if(destination?.evStationDetails?.chargeLevel; as chargerLevel) {
  <app-charging-level-list
    [dcFast]="chargerLevel.dcFast"
    [level1]="chargerLevel.level1"
    [level2]="chargerLevel.level2"></app-charging-level-list>
} @else {
  <ion-grid class="ion-no-padding">
    <ion-row class="info-section ion-align-items-center">
      <ion-col class="icon-column" size="auto">
        @if(isOwnedShop()) {
          <icon-aaa-logo alt="AAA logo" i18n-alt class="logo" />
        } @else {
          <ion-button size="small">
            <aaa-text size="title3" weight="regular">$</aaa-text>
          </ion-button>
        }
      </ion-col>
      <ion-col>
        <ion-row>
          <ion-col>
            <aaa-text class="title">{{ getTitle() }}</aaa-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <aaa-text class="subtitle description" display="flex" align="left" i18n>Up To $75 Off Labor</aaa-text>
          </ion-col>
        </ion-row>
        @if(destination.ratingSummary?.reviewCount > 0 && destination.ratingSummary?.ratingAvg >= 3.5) {
          <ion-col class="info-column" size="auto">
            <ion-row class="title ratings">
              <app-rating class="margin-right-4" [rate]="destination.ratingSummary.ratingAvg"></app-rating>
              <aaa-text i18n>{{ destination.ratingSummary.ratingAvg | number:'1.0-1' }}</aaa-text>
            </ion-row>
            <ion-row class="ion-justify-content-end">
              <app-reviews-count [numberReviews]="destination.ratingSummary.reviewCount"></app-reviews-count>
            </ion-row>
          </ion-col>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
}
